import GradientBackground from '../components/GradientBackground/GradientBackground';
import StampHistory from '../components/StampHistory/StampHistory';

const Stamps = () => {
  return (
    <main className="overflow-hidden relative flex align-center justify-center flex-col">
      <div className="relative flex items-center h-20 md:h-[125px] px-4 sm:px-8 md:px-[60px]">
        <GradientBackground />
        <h1 className="z-10 text-2xl sm:text-3xl md:text-[40px] font-normal">Stamp History</h1>
      </div>
      <div className="relative p-4 sm:p-8 md:p-[60px] bg-black">
        <StampHistory />
      </div>
    </main>
  );
};

export default Stamps;
